// extracted by mini-css-extract-plugin
export var bubble = "_3m-0";
export var container = "_3m-f";
export var contrastBorder = "_3m-g";
export var greyOut = "_3m-2";
export var initialsColor0 = "_3m-3";
export var initialsColor1 = "_3m-4";
export var initialsColor10 = "_3m-d";
export var initialsColor11 = "_3m-e";
export var initialsColor2 = "_3m-5";
export var initialsColor3 = "_3m-6";
export var initialsColor4 = "_3m-7";
export var initialsColor5 = "_3m-8";
export var initialsColor6 = "_3m-9";
export var initialsColor7 = "_3m-a";
export var initialsColor8 = "_3m-b";
export var initialsColor9 = "_3m-c";
export var initialsWrapper = "_3m-1";
export var large = "_3m-l";
export var medium = "_3m-k";
export var mediumSmall = "_3m-j";
export var mediumSmallMedium = "_3m-o";
export var micro = "_3m-h";
export var small = "_3m-i";
export var tiny = "_3m-n";
export var xTiny = "_3m-m";